import { IconLink } from '@iwoca/icons';
import { Button, Link } from '@iwoca/orion';

import styles from './ShareLinkOpenBanking.module.css';

export const ShareLinkOpenBanking = () => {
  const businessNamePlaceholder = 'Iwoca';

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <h1 className={styles.title}>
          {businessNamePlaceholder} needs your help to finish their loan
          application.
        </h1>
        <h2 className={styles.subTitle}>
          You have been requested to link their business bank account via our
          secure platform.
        </h2>
        <p className={styles.description}>
          We are{' '}
          <Link
            className={styles.link}
            href="https://www.iwoca.co.uk/about-us"
            target="_blank"
            rel="noopener noreferrer"
          >
            iwoca
          </Link>
          , a business lender. We require the steps below to be completed in
          order to assess their suitability for credit.
        </p>
      </div>
      <p className={styles.description}>
        <strong>
          Link {businessNamePlaceholder}’s business bank account using Open
          Banking
        </strong>
      </p>
      <ul className={styles.list}>
        <li>
          We’re{' '}
          <Link
            className={styles.link}
            href="https://www.fca.org.uk/about/what-we-do/the-fca"
            target="_blank"
            rel="noopener noreferrer"
          >
            FCA regulated
          </Link>{' '}
          which means we can use Open Banking. Open Banking with TrueLayer is a
          secure way to share your account information without sharing your
          password.{' '}
          <Link
            className={styles.link}
            href="https://truelayer.com/reports/open-banking-guide/what-is-open-banking/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn more
          </Link>
          .
        </li>
        <li>
          Your transactions must cover the stated period and be from the
          account(s) where the majority of your business revenue is received.
        </li>
      </ul>
      <div>
        <Button>
          Link bank account <IconLink />
        </Button>
      </div>
    </div>
  );
};
